var _style, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubbleShapeGame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 140 140",
    style: {
      enableBackground: "new 0 0 140 140"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.bubbleshapest0{fill:currentColor;stroke: none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BG"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "bubbleshapest0",
    d: "M70,2C32.5,2,2,32.5,2,70c0,37.5,30.5,68,68,68c12.7,0,25.1-3.5,35.8-10.2l20.4,6.4c0.6,0.2,1.3,0.3,1.9,0.3 c2,0,3.9-1,5.1-2.6c1.2-1.6,1.5-3.7,0.9-5.6l-6.4-20.4C134.5,95.1,138,82.7,138,70C138,32.5,107.5,2,70,2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "bubbleshapest0",
    cx: 70,
    cy: 70,
    r: 65
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleShapeGame);
export default __webpack_public_path__ + "static/media/BubbleShape_Game.06e4909ad8cea09f10dfe7f06903fb79.svg";
export { ForwardRef as ReactComponent };